import { useState } from "react";

import { Button } from "@/components/ui/button";
import { ConfirmDialog } from "@/pages/tina/festivals/components/confirm-dialog";
import { rejectText } from "@/pages/tina/festivals/lib/page-copy";
import type { FestivalPageRead } from "@/types/tina-festival-page";

interface RejectButtonProps {
  page: FestivalPageRead;
  disabled: boolean;
  onConfirm: () => void;
}

/** "Reject" behind a confirmation that says what it does: a rejected festival is never proposed again. */
export function RejectButton({ page, disabled, onConfirm }: RejectButtonProps) {
  const [open, setOpen] = useState(false);
  const text = rejectText(page);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Reject
      </Button>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={text.title}
        description={text.description}
        confirmLabel="Reject"
        cancelLabel="Keep it"
        onConfirm={onConfirm}
      />
    </>
  );
}
